
export default {
  async asyncData({ $axios, $fatal }) {
    return {
      status: await $axios.$get('/status').catch($fatal),
      stats: await $axios.$get('/stats').catch($fatal),
    }
  },
  data() {
    return {
      interval: '',
    }
  },
  head: {
    title: 'Status',
  },
  computed: {
    connectedShards() {
      return this.status.filter(element => element.status === 'Connected').length
    },
    connectedPercent() {
      return Math.floor((this.connectedShards / this.stats.shards) * 100)
    },
  },
  mounted() {
    this.interval = setInterval(() => this.$nuxt.refresh(), 30000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    durationSince(timestamp) {
      if (timestamp === '0001-01-01T00:00:00') {
        return 'Never'
      }

      const diff = new Date() - new Date(timestamp + 'Z')
      const result = []

      const seconds = Math.floor((diff / 1000) % 60)
      const minutes = Math.floor((diff / (1000 * 60)) % 60)
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24)
      const days = Math.floor(diff / (1000 * 60 * 60 * 24))

      if (days) result.push(`${days}d`)
      if (hours) result.push(`${hours}h`)
      if (minutes) result.push(`${minutes}m`)
      if (seconds) result.push(`${seconds}s`)

      return result.join(' ')
    },
    popoverContent(shard) {
      return {
        content: `
          <p class="h6 font-weight-bold mb-2">Shard ${shard.shard}</p>
          <p class="mb-0">Status: ${shard.status}</p>
          <p class="mb-0">Latency: ${shard.latency}ms</p>
          <p class="mb-0">Last heartbeat: ${this.durationSince(shard.last_ack)}</p>
        `,
        html: true,
      }
    },
  },
}
